import { render } from "./esign_consent.vue?vue&type=template&id=378b1a08"
import script from "./esign_consent.vue?vue&type=script&lang=js"
export * from "./esign_consent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__